import { processLoggers } from './config.js';

var middlewareMap = {};

var loggingMiddleware = function loggingMiddleware() {
  return function (store) {
    return function (next) {
      return function (action) {
        // check middlewares setup
        processLoggers(function (logger) {
          if (!middlewareMap[logger.type] && logger.getMiddleware) {
            var mw = logger.getMiddleware();

            if (mw) {
              middlewareMap[logger.type] = mw(store);
            }
          }
        }); // intercept and process each middleware

        var middlewares = Object.values(middlewareMap);
        var theNext = middlewares.reduce(function (acc, mw) {
          return mw(acc);
        }, next);
        return theNext(action);
      };
    };
  };
};

var loggingMiddleware$1 = loggingMiddleware;

export { loggingMiddleware$1 as default };
